module.exports = __webpack_public_path__ + "img/address.7fd812bc.svg";